export default {
    C002: 'COMPANY_ALREADY_EXISTS',
    U004: 'COMPANY_OWNER_ALREADY_ASSIGNED',
};
